import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as actions from '../store/actions'
import { AppContext } from '../../../global'
import { ResponsiveLine } from '@nivo/line'
import { RequestState } from '../../types'

import './SubscriptionsChartWidget.css'
import PanelWithHeader from '../../../components/panels/PanelWithHeader'

type Props = {
  partnerId: string
}

function SubscriptionsChartWidget(props: Props) {
  const { state, execute } = useContext(AppContext)
  const partnerId = props.partnerId

  const { data, requestState } = state.dashboard.subscriptionChartData
  const { t } = useTranslation(['dashboard'])

  const dataTrans = data ? data.map((line) => ({ ...line, id: t(line.id)})): []

  useEffect(
    () => {
      execute(actions.loadSubscriptionGraphData(partnerId))
    },
    // eslint-disable-next-line
    [partnerId]
  )

  return (
    <PanelWithHeader title={t('subscriptions_by_month.title')}>
      {requestState === RequestState.Loading && (
        <div className="panel-loading">
          <i className="fas fa-spinner fa-spin font-size-xl"></i>
        </div>
      )}

      {requestState === RequestState.Error && (
        <div className="panel-loading">
          <i className="fas fa-exclamation-circle font-size-xl"></i>
          <p>{t('subscriptions_by_month.error')}</p>
        </div>
      )}

      {requestState === RequestState.Loaded && data && (
        <div id="subscription-chart">
          <ResponsiveLine
            data={dataTrans}
            margin={{ top: 40, right: 20, bottom: 70, left: 50 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              orient: 'bottom',
              tickRotation: -45,
              tickSize: 5,
              tickPadding: 5,
              legend: t('month'),
              legendOffset: 50,
              legendPosition: 'middle'
            }}
            axisLeft={{
              orient: 'left',
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: t('count'),
              legendOffset: -40,
              legendPosition: 'middle'
            }}
            colors={['red', 'green']}
            enablePoints={true}
            useMesh={false}
            legends={[
              {
                anchor: 'top-right',
                direction: 'row',
                justify: false,
                translateX: -20,
                translateY: -30,
                itemsSpacing: 5,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                  {
                    on: 'hover',
                    style: {
                      itemBackground: 'rgba(0, 0, 0, .03)',
                      itemOpacity: 1
                    }
                  }
                ]
              }
            ]}
          />
        </div>
      )}
    </PanelWithHeader>
  )
}

export default SubscriptionsChartWidget
